export default __webpack_public_path__ + "static/media/blessingofmitra.50af54dd.png";